import { render, staticRenderFns } from "./ModalEmailSeller.vue?vue&type=template&id=765cbd52&scoped=true"
import script from "./ModalEmailSeller.vue?vue&type=script&lang=js"
export * from "./ModalEmailSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765cbd52",
  null
  
)

export default component.exports